export const SET_NAVBAR_INFO = "SET_NAVBAR_INFO";
export const SET_NAVBAR_INFO_LOADING = "SET_NAVBAR_INFO_LOADING";


export const GET_BUSINESS_DATE_SUCCESS = "GET_BUSINESS_DATE_SUCCESS"
export const GET_BUSINESS_DATE = "GET_BUSINESS_DATE"

export interface GetBusinessDateResponseBody {
    result: {
        company: string;
        companyName: string;
        businessDate: string;
    },
    message: string;
    isSuccess: boolean;
    environment: string;
}